export default __webpack_public_path__ + "static/media/update-icon.1e64a7bc.svg";